import { render } from "./ApprovedPaymentReversals.vue?vue&type=template&id=36fb4a11&scoped=true"
import script from "./ApprovedPaymentReversals.vue?vue&type=script&lang=js"
export * from "./ApprovedPaymentReversals.vue?vue&type=script&lang=js"

import "./ApprovedPaymentReversals.vue?vue&type=style&index=0&id=36fb4a11&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36fb4a11"]])

export default __exports__